// todo: fix enum imports from @amzn/aac-chrome-internal-api

import { AdvertisingAccountType } from '@amzn/aac-chrome-internal-api';
import { MessageBundle } from '@amzn/arb-tools'; // seperate mapping for account dropdown pill because it is formatted differently

// seperate mapping for account dropdown pill because it is formatted differently
export const ACCOUNT_TYPE_PILL_LABEL_MAP = new Map([
  [
    AdvertisingAccountType.GLOBAL,
    'account-switcher-pill-global-single-global-label',
  ],
  [AdvertisingAccountType.SPONSORED_ADS, 'account-switcher-pill-sa-label'],
  [AdvertisingAccountType.DSP_ENTITY, 'account-switcher-pill-dsp-entity-label'],
  [
    AdvertisingAccountType.DSP_ADVERTISER,
    'account-switcher-pill-dsp-advertiser-label',
  ],
  [
    AdvertisingAccountType.MANAGER,
    'account-switcher-pill-manager-account-label',
  ],
  [AdvertisingAccountType.AMC, 'account-switcher-pill-amc-label'],
]);

// used for account switcher mapping
export const ACCOUNT_TYPE_FILTER_LABEL_MAP = new Map([
  [
    AdvertisingAccountType.GLOBAL,
    'account-switcher-filter-single-global-account-label',
  ],
  [AdvertisingAccountType.SPONSORED_ADS, 'account-switcher-filter-sa-label'],
  [
    AdvertisingAccountType.DSP_ENTITY,
    'account-switcher-filter-dsp-entities-label',
  ],
  [
    AdvertisingAccountType.DSP_ADVERTISER,
    'account-switcher-filter-dsp-advertisers-label',
  ],
  [
    AdvertisingAccountType.MANAGER,
    'account-switcher-filter-manager-account-label',
  ],
  [AdvertisingAccountType.AMC, 'account-switcher-filter-amc-label'],
]);

export const ACCOUNT_TYPE_LIST_LABEL_MAP = new Map([
  [
    AdvertisingAccountType.GLOBAL,
    'account-switcher-list-heading-single-global-account',
  ],
  [AdvertisingAccountType.SPONSORED_ADS, 'account-switcher-list-heading-sa'],
  [
    AdvertisingAccountType.DSP_ENTITY,
    'account-switcher-list-heading-dsp-entity',
  ],
  [
    AdvertisingAccountType.DSP_ADVERTISER,
    'account-switcher-list-heading-dsp-advertiser',
  ],
  [AdvertisingAccountType.MANAGER, 'account-switcher-list-heading-manager'],
  [AdvertisingAccountType.AMC, 'account-switcher-list-heading-amc'],
]);

export const ACCOUNT_CARD_TYPE = new Map([
  [AdvertisingAccountType.GLOBAL, 'account-card-type-single-global'],
  [AdvertisingAccountType.SPONSORED_ADS, 'account-card-type-sa'],
  [AdvertisingAccountType.DSP_ENTITY, 'account-card-type-dsp-entity'],
  [AdvertisingAccountType.DSP_ADVERTISER, 'account-card-type-dsp-advertiser'],
  [AdvertisingAccountType.MANAGER, 'account-card-type-manager'],
  [AdvertisingAccountType.AMC, 'account-card-type-amc'],
]);

const generateGetLabelFn = (
  map: Map<AdvertisingAccountType, string>,
): ((accountType: AdvertisingAccountType, bundle: MessageBundle) => string) => {
  return (
    accountType: AdvertisingAccountType,
    bundle: MessageBundle,
  ): string => {
    const key = map.get(accountType);
    return key ? bundle.getMessage(key) : ''; // fallback to empty string for label
  };
};

export const getAccountTypeFilterLabel = generateGetLabelFn(
  ACCOUNT_TYPE_FILTER_LABEL_MAP,
);

export const getAccountTypeListLabel = generateGetLabelFn(
  ACCOUNT_TYPE_LIST_LABEL_MAP,
);
